<div class="override-toggle">
    <cerrix-checkbox
        data-uiid="use-parent-or-default-matrix"
        [label]="'organizationRiskmatrixEditor.useParentOrDefaultMatrixLabel' | transloco"
        [(value)]="row.UseParentOrDefaultMatrix"
    ></cerrix-checkbox>
</div>
<hr />
@if (row.UseParentOrDefaultMatrix) {
    <div class="parent-matrix-viewer">
        @if (row.ParentMatrix) {
            <label>
                {{ "organizationRiskmatrixEditor.parentMatrixPreviewLabel" | transloco }}
            </label>
            <cerrix-riskmatrix-summary
                [matrix]="row.ParentMatrix"
                [cellSize]="cellSize"
                [cellSpacing]="cellSpacing"
            ></cerrix-riskmatrix-summary>
        } @else {
            <label>
                {{ "organizationRiskmatrixEditor.noParentMatrixPreviewLabel" | transloco }}
            </label>
        }
    </div>
} @else {
    @if (value) {
        <div class="risk-matrix-editor">
            @if (summaryListConfig) {
                @let summaryColorsName =
                    "organizationRiskmatrixEditor.summaryColorsName" | transloco;
                <div class="left-area">
                    <ng-container
                        *ngComponentOutlet="
                            listManagerType;
                            inputs: { config: withSummaryListName(summaryColorsName) }
                        "
                    ></ng-container>
                </div>
            }

            <div class="right-area">
                <cerrix-riskmatrix-summary
                    [matrix]="value"
                    [cellSize]="cellSize"
                    [cellSpacing]="cellSpacing"
                    (cellClick)="matrixCellClick($event.Likelihood, $event.Impact)"
                ></cerrix-riskmatrix-summary>
            </div>
        </div>
    }
}
